(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ml-comparison')) {
    customElements.define('ml-comparison', class extends HTMLElement {
      connectedCallback() { this.frame = requestAnimationFrame(() => this.setup()); }
      disconnectedCallback() { cancelAnimationFrame(this.frame); this.events?.abort(); this.observer?.disconnect(); }
      setup() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const activeId = this.querySelector('.ml-cmp__tab[aria-selected="true"]')?.getAttribute('aria-controls');
        const desktop = matchMedia('(min-width: 750px)');
        desktop.addEventListener('change', () => this.setup(), options);
        const allPanels = [...this.querySelectorAll('[data-compare-panel]')];
        this.panels = allPanels.filter(panel => !desktop.matches || panel.dataset.hideDesktop !== 'true');
        this.nav = this.querySelector('.ml-cmp__nav');
        this.nav.replaceChildren();
        this.removeAttribute('data-tabs-ready');
        this.nav.removeAttribute('role');
        allPanels.forEach(panel => { panel.hidden = !this.panels.includes(panel); panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); });
        const showTabs = this.dataset.showPills === 'true' && (this.panels.length > 1 || this.dataset.hideSingle !== 'true');
        this.panels.forEach(panel => {
          const titles = [...panel.querySelectorAll('thead [data-column-title]')].map(el => el.textContent.trim());
          panel.querySelectorAll('tbody [data-column], tfoot [data-column]').forEach(cell => {
            const label = cell.querySelector('.ml-cmp__mobile-column');
            if (label) label.textContent = titles[Number(cell.dataset.column) - 1] || '';
          });
          const scroll = panel.querySelector('.ml-cmp__scroll');
          scroll.addEventListener('scroll', () => this.updateOverflow(panel), { ...options, passive: true });
          panel.querySelectorAll('[data-scroll-direction]').forEach(button => button.addEventListener('click', () => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            const step = panel.querySelector('thead [data-column]')?.getBoundingClientRect().width || scroll.clientWidth * .7;
            scroll.scrollBy({ left: step * (button.dataset.scrollDirection === 'next' ? 1 : -1) * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          }, options));
          if (!showTabs) return;
          const tab = document.createElement('a');
          tab.className = 'ml-cmp__tab';
          tab.id = `tab-${panel.id}`;
          tab.href = `#${panel.id}`;
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          const iconSource = panel.querySelector('template[data-compare-icon]');
          if (iconSource?.content.querySelector('svg, img')) {
            const icon = document.createElement('span');
            icon.className = 'ml-cmp__tab-icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.append(iconSource.content.cloneNode(true));
            tab.append(icon);
          }
          const label = document.createElement('span');
          label.textContent = panel.dataset.label;
          tab.append(label);
          this.nav.append(tab);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          const index = this.panels.indexOf(panel);
          tab.addEventListener('click', event => { event.preventDefault(); this.activate(index, false, true); }, options);
          tab.addEventListener('keydown', event => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next = index;
            if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.panels.length - 1;
            else if (event.key === ' ') { event.preventDefault(); this.activate(index, false, true); return; }
            else return;
            event.preventDefault();
            this.activate((next + this.panels.length) % this.panels.length, true, true);
          }, options);
        });
        this.tabs = [...this.nav.querySelectorAll('[role="tab"]')];
        if (showTabs && this.tabs.length) {
          this.nav.setAttribute('role', 'tablist');
          this.dataset.tabsReady = '';
          this.activate(Math.max(0, this.panels.findIndex(panel => panel.id === activeId)));
        }
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.contains(event.target) || panel === event.target);
          if (index >= 0 && this.tabs.length) this.activate(index, false, true);
        }, options);
        this.dataset.ready = '';
        this.observer = new ResizeObserver(entries => {
          const pillsChanged = entries.some(entry => entry.target === this.nav || this.tabs.includes(entry.target));
          if (pillsChanged) this.centerSelected(false);
          this.panels.forEach(panel => this.updateOverflow(panel));
        });
        this.observer.observe(this.nav);
        this.panels.forEach(panel => this.observer.observe(panel.querySelector('.ml-cmp__scroll')));
        this.tabs.forEach(tab => this.observer.observe(tab));
        this.centerSelected(false);
        this.panels.forEach(panel => this.updateOverflow(panel));
      }
      activate(index, focus = false, animate = false) {
        this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.panels[i].hidden = i !== index; });
        if (focus) this.tabs[index]?.focus({ preventScroll: true });
        this.centerSelected(animate);
        this.updateOverflow(this.panels[index]);
      }
      centerSelected(animate) {
        const active = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
        if (!active) return;
        const mobile = matchMedia('(max-width: 749px)').matches;
        const widths = this.tabs.map(tab => tab.getBoundingClientRect().width);
        const gap = parseFloat(getComputedStyle(this.nav).columnGap) || 0;
        const overflow = widths.reduce((sum, width) => sum + width, 0) + gap * (widths.length - 1) + 8 > this.nav.clientWidth + 1;
        if (!mobile && !overflow) {
          this.nav.style.justifyContent = 'center';
          this.nav.style.setProperty('--ml-cmp-edge-start', '4px');
          this.nav.style.setProperty('--ml-cmp-edge-end', '4px');
          this.nav.scrollTo({ left: 0, behavior: 'instant' });
          return;
        }
        this.nav.style.justifyContent = 'flex-start';
        this.nav.style.setProperty('--ml-cmp-edge-start', '4px');
        this.nav.style.setProperty('--ml-cmp-edge-end', `${Math.max(4, (this.nav.clientWidth - widths.at(-1)) / 2)}px`);
        const bounds = active.getBoundingClientRect();
        const viewport = this.nav.getBoundingClientRect();
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.nav.scrollTo({
          left: active === this.tabs[0] ? 0 : this.nav.scrollLeft + bounds.left + bounds.width / 2 - viewport.left - viewport.width / 2,
          behavior: animate && !reducedMotion ? 'smooth' : 'instant'
        });
      }
      updateOverflow(panel) {
        if (!panel || panel.hidden) return;
        const scroll = panel.querySelector('.ml-cmp__scroll');
        const tools = panel.querySelector('.ml-cmp__scroll-tools');
        const max = scroll.scrollWidth - scroll.clientWidth;
        tools.hidden = max < 2 || this.dataset.showScrollTools !== 'true';
        tools.querySelector('[data-scroll-direction="prev"]').disabled = Math.abs(scroll.scrollLeft) < 2;
        tools.querySelector('[data-scroll-direction="next"]').disabled = Math.abs(scroll.scrollLeft) >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ml-footer')) {
    customElements.define('ml-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const media = window.matchMedia('(max-width: 749px)');
        const menus = [...this.querySelectorAll('.ml-footer__menu')];
        const update = () => {
          for (const menu of menus) {
            menu.open = !media.matches || this.dataset.collapseMobile !== 'true';
            menu.querySelector('summary').tabIndex = media.matches ? 0 : -1;
          }
        };
        update();
        media.addEventListener('change', update, { signal });
        this.addEventListener('change', event => {
          if (event.target instanceof HTMLSelectElement && event.target.closest('.ml-footer__localization')) {
            if (event.target.name === 'country_code' && event.target.value === 'CH') {
              window.location.assign('https://matchaland.ch/');
              return;
            }
            event.target.form?.requestSubmit();
          }
        }, { signal });
        this.addEventListener('click', event => {
          if (!media.matches && event.target.closest('.ml-footer__menu-summary')) event.preventDefault();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) {
            const menu = event.target.closest('.ml-footer__menu-column')?.querySelector('details');
            if (menu) menu.open = true;
          }
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-image-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ml-image-tabs')) {
    customElements.define('ml-image-tabs', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.events?.abort();
      }
      setup() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.panels = [...this.querySelectorAll('[data-panel]')];
        const nav = this.querySelector('.ml-tabs__nav');
        nav.replaceChildren();
        this.panels.forEach(panel => {
          const tab = document.createElement('a');
          tab.className = 'ml-tabs__tab';
          tab.id = 'ml-tab-' + panel.id;
          tab.href = '#' + panel.id;
          tab.dataset.tab = panel.dataset.panel;
          const label = document.createElement('span');
          label.textContent = panel.dataset.label;
          const source = panel.querySelector('template[data-pill-icon]');
          if (source?.content.querySelector('svg, img')) {
            const icon = document.createElement('span');
            icon.className = 'ml-tabs__pill-icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.append(source.content.cloneNode(true));
            if (source.dataset.position === 'after') tab.append(label, icon);
            else tab.append(icon, label);
          } else tab.append(label);
          nav.append(tab);
        });
        this.tabs = [...nav.querySelectorAll('[data-tab]')];
        if (!this.tabs.length) return;
        this.querySelector('.ml-tabs__nav').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', this.panels[index].id);
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(index, false, true);
          }, options);
          tab.addEventListener('keydown', (event) => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next = index;
            if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
            else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else if (event.key === ' ') { event.preventDefault(); this.activate(index, false, true); return; }
            else return;
            event.preventDefault();
            this.activate((next + this.tabs.length) % this.tabs.length, true, true);
          }, options);
        });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex(panel => panel.dataset.panel === event.detail.blockId || panel.contains(event.target));
          if (index >= 0) this.activate(index, false, true);
        }, options);
        const selected = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
        this.activate(selected >= 0 ? selected : 0);
        this.dataset.ready = '';
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.centerSelected(false));
        this.resizeObserver.observe(this.querySelector('.ml-tabs__nav'));
        this.tabs.forEach(tab => this.resizeObserver.observe(tab));
      }
      activate(index, focus = false, scroll = false) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
        const tab = this.tabs[index];
        if (focus) tab.focus({ preventScroll: true });
        this.centerSelected(scroll);
      }
      centerSelected(animate) {
        const nav = this.querySelector('.ml-tabs__nav');
        const active = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
        if (!active) return;
        const mobile = matchMedia('(max-width: 749px)').matches;
        const widths = this.tabs.map(tab => tab.getBoundingClientRect().width);
        const gap = parseFloat(getComputedStyle(nav).columnGap) || 0;
        const overflow = widths.reduce((sum, width) => sum + width, 0) + gap * (widths.length - 1) + 8 > nav.clientWidth + 1;
        if (!mobile && !overflow) {
          nav.style.justifyContent = 'center';
          nav.style.setProperty('--ml-edge-start', '4px');
          nav.style.setProperty('--ml-edge-end', '4px');
          nav.scrollTo({ left: 0, behavior: 'instant' });
          return;
        }
        nav.style.justifyContent = 'flex-start';
        nav.style.setProperty('--ml-edge-start', '4px');
        nav.style.setProperty('--ml-edge-end', `${Math.max(4, (nav.clientWidth - widths.at(-1)) / 2)}px`);
        const bounds = active.getBoundingClientRect();
        const viewport = nav.getBoundingClientRect();
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        nav.scrollTo({
          left: active === this.tabs[0] ? 0 : nav.scrollLeft + bounds.left + bounds.width / 2 - viewport.left - viewport.width / 2,
          behavior: animate && !reducedMotion ? 'smooth' : 'instant'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-image-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ml-image-wall')) {
    customElements.define('ml-image-wall', class extends HTMLElement {
      connectedCallback() { this.initFrame = requestAnimationFrame(() => this.setup()); }
      setup() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.gallery = this.querySelector('.ml-wall__gallery');
        this.source = this.querySelector('.ml-wall__source');
        this.columns = this.querySelector('.ml-wall__columns');
        this.cards = [...this.source.querySelectorAll(':scope > .ml-wall__tile')];
        this.button = this.querySelector('.ml-wall__motion');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.pausedByUser = false;
        this.inView = false;
        this.lastLayout = '';
        this.layout();
        this.resizeObserver = new ResizeObserver(() => this.queueLayout());
        this.resizeObserver.observe(this.gallery);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries[entries.length - 1].isIntersecting;
          this.updateMotion();
        });
        this.intersectionObserver.observe(this.gallery);
        this.button.addEventListener('click', () => {
          this.pausedByUser = !this.pausedByUser;
          this.updateMotion();
        }, { signal });
        this.mobile.addEventListener('change', () => this.queueLayout(), { signal });
        this.reduced.addEventListener('change', () => this.updateMotion(), { signal });
        document.addEventListener('visibilitychange', () => this.updateMotion(), { signal });
        this.gallery.addEventListener('mousedown', event => {
          if (event.target.closest('[data-ml-wall-clone] a')) event.preventDefault();
        }, { signal });
        this.gallery.addEventListener('focusin', event => {
          if (event.target.closest('.ml-wall__tile')) {
            this.dataset.focus = 'true';
            event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          } else {
            this.dataset.focus = 'false';
            this.columns.querySelectorAll('.ml-wall__column').forEach(column => { column.scrollTop = 0; });
          }
        }, { signal });
        this.gallery.addEventListener('focusout', event => {
          if (!this.gallery.contains(event.relatedTarget)) {
            this.dataset.focus = 'false';
            this.columns.querySelectorAll('.ml-wall__column').forEach(column => { column.scrollTop = 0; });
          }
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target)) {
            this.pausedByUser = true;
            this.updateMotion();
          }
        }, { signal });
        this.updateMotion();
      }
      queueLayout() {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.layout());
      }
      clone(element) {
        const copy = element.cloneNode(true);
        copy.dataset.mlWallClone = 'true';
        copy.setAttribute('aria-hidden', 'true');
        for (const node of [copy, ...copy.querySelectorAll('*')]) {
          node.removeAttribute('id');
          for (const name of node.getAttributeNames()) {
            if (name.startsWith('data-shopify')) node.removeAttribute(name);
          }
          if (node.matches('a, button, [tabindex]')) node.tabIndex = -1;
        }
        return copy;
      }
      layout() {
        if (!this.cards.length || !this.isConnected) return;
        const count = Math.min(Number(this.mobile.matches ? this.dataset.mobileColumns : this.dataset.columns), this.cards.length);
        const width = Math.round(this.gallery.getBoundingClientRect().width);
        const height = Math.round(this.gallery.getBoundingClientRect().height);
        const key = [count, width, height, this.mobile.matches].join(':');
        if (!width || !height || key === this.lastLayout) return;
        this.lastLayout = key;
        this.source.append(...this.cards);
        this.columns.replaceChildren();
        this.style.setProperty('--ml-wall-actual-cols', count);
        this.dataset.ready = 'true';
        const groups = [];
        for (let index = 0; index < count; index++) {
          const column = document.createElement('div');
          column.className = 'ml-wall__column';
          if (this.dataset.direction === 'down' || this.dataset.direction === 'alternate' && index % 2) column.classList.add('ml-wall__column--reverse');
          const track = document.createElement('div');
          track.className = 'ml-wall__track';
          const group = document.createElement('div');
          group.className = 'ml-wall__set';
          track.append(group);
          column.append(track);
          this.columns.append(column);
          groups.push(group);
        }
        this.cards.forEach((card, index) => groups[index % count].append(card));
        const pixelsPerSecond = 5 + 5 * Number(this.mobile.matches ? this.dataset.mobileSpeed : this.dataset.speed);
        for (const group of groups) {
          const originals = [...group.children];
          let loops = 0;
          while (group.getBoundingClientRect().height < height + 1 && loops++ < 24) {
            originals.forEach(card => group.append(this.clone(card)));
          }
          group.parentElement.style.setProperty('--ml-wall-duration', (group.getBoundingClientRect().height / pixelsPerSecond) + 's');
          group.parentElement.append(this.clone(group));
        }
        this.dataset.ready = 'true';
      }
      updateMotion() {
        const available = this.dataset.animate === 'true' && this.dataset.editorPaused !== 'true' && !this.reduced.matches && this.cards.length > 0;
        this.dataset.playing = String(available && this.inView && !document.hidden && !this.pausedByUser);
        this.button.hidden = !available;
        this.button.setAttribute('aria-pressed', String(this.pausedByUser));
        this.button.setAttribute('aria-label', this.pausedByUser ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.layoutFrame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-multicolumn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ml-multicolumn')) {
    customElements.define('ml-multicolumn', class extends HTMLElement {
      connectedCallback() { this.startFrame = requestAnimationFrame(() => this.setup()); }
      setup() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ml-multi__track');
        this.cards = [...this.track.children].filter(card => card.matches('.ml-multi__card'));
        this.headingBadges = new Map();
        this.positionHeadingBadges();
        this.badges = [...this.track.querySelectorAll('.ml-multi__badge')];
        this.headingBadgeObserver = new MutationObserver(() => this.positionHeadingBadges());
        this.headingBadgeObserver.observe(this.track, { childList: true, subtree: true });
        this.controls = this.querySelector('.ml-multi__controls');
        this.dots = this.querySelector('.ml-multi__dots');
        this.counter = this.querySelector('.ml-multi__counter');
        this.status = this.querySelector('.ml-multi__status');
        this.previous = this.querySelector('.ml-multi__prev');
        this.next = this.querySelector('.ml-multi__next');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.dots.addEventListener('click', event => {
          const dot = event.target.closest('[data-page]');
          if (dot) this.go(Number(dot.dataset.page));
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
          clearTimeout(this.announceTimer);
          this.announceTimer = setTimeout(() => this.announce(), 150);
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !this.active) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault(); this.go(event.key === 'Home' ? 0 : this.points.length - 1);
          }
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.ml-multi__card');
          if (card && this.contains(card) && this.active) this.track.scrollTo({ left: this.offset(card), behavior: 'instant' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.layout());
        });
        this.resizeObserver.observe(this.track);
        this.badges.forEach(badge => this.resizeObserver.observe(badge));
        this.mobile.addEventListener('change', () => this.layout(), { signal });
        this.layout();
      }
      positionHeadingBadges() {
        const cards = [...this.track.querySelectorAll(':scope > .ml-multi__card')];
        const currentCards = new Set(cards);
        for (const card of this.headingBadges.keys()) {
          if (!currentCards.has(card)) this.headingBadges.delete(card);
        }
        for (const card of cards) {
          if (card.dataset.badgePosition !== 'heading' || !card.dataset.badgeText) {
            this.headingBadges.delete(card);
            continue;
          }
          const copy = card.querySelector(':scope > .ml-multi__surface > .ml-multi__copy');
          if (!copy) continue;
          const badge = copy.querySelector('.ml-multi__badge--heading') || this.headingBadges.get(card);
          if (!badge) continue;
          this.headingBadges.set(card, badge);
          const label = badge.querySelector('.ml-multi__badge-label > span');
          if (label && label.textContent !== card.dataset.badgeText) label.textContent = card.dataset.badgeText;
          let heading;
          for (const text of copy.querySelectorAll('.text-block')) {
            heading = [...text.children].find(child => child.matches('h1, h2, h3, h4, h5, h6'));
            if (!heading && text.matches('.h1, .h2, .h3, .h4, .h5, .h6')) {
              heading = [...text.children].find(child => !child.matches('.ml-multi__badge'));
            }
            if (heading) break;
          }
          const parent = heading?.parentElement || copy;
          const next = heading || copy.firstChild;
          if (badge.parentElement !== parent || (heading && badge.nextElementSibling !== heading)) {
            parent.insertBefore(badge, next === badge ? badge.nextSibling : next);
          }
        }
      }
      offset(card) { return card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft; }
      layout() {
        const floatingBadges = this.badges.filter(badge => badge.matches('.ml-multi__badge--floating, .ml-multi__badge--floating-center, .ml-multi__badge--floating-right'));
        const clearance = Math.ceil(Math.max(16, ...floatingBadges.map(badge => badge.getBoundingClientRect().height / 2 + 2)));
        this.track.style.setProperty('--mm-badge-clearance', `${clearance}px`);
        this.track.style.setProperty('--mm-badge-row-gap', floatingBadges.length ? `${clearance}px` : '0px');
        this.active = (this.mobile.matches ? this.dataset.mobile : this.dataset.desktop) === 'carousel';
        this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const candidates = this.cards.map(card => Math.max(0, Math.min(this.max, this.offset(card))));
        this.points = [];
        for (const point of candidates) if (!this.points.length || point - this.points[this.points.length - 1] > 2) this.points.push(point);
        if (!this.points.length) this.points = [0];
        const pagination = this.mobile.matches ? this.dataset.paginationMobile : this.dataset.pagination;
        const arrows = this.mobile.matches ? this.dataset.arrowsMobile : this.dataset.arrows;
        this.controls.hidden = !this.active || this.max < 2 || (pagination === 'none' && arrows !== 'true');
        this.track.tabIndex = this.active && this.max > 2 ? 0 : -1;
        if (this.dots.children.length !== this.points.length) {
          this.dots.replaceChildren(...this.points.map((point, index) => {
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'ml-multi__dot'; button.dataset.page = index;
            button.setAttribute('aria-label', this.dots.dataset.label.replace('[number]', index + 1));
            button.setAttribute('aria-controls', this.track.id);
            return button;
          }));
        }
        if (!this.active && this.track.scrollLeft) this.track.scrollTo({ left: 0, behavior: 'instant' });
        this.update();
      }
      update() {
        let nearest = 0;
        this.points.forEach((point, index) => { if (Math.abs(point - this.track.scrollLeft) < Math.abs(this.points[nearest] - this.track.scrollLeft)) nearest = index; });
        this.current = nearest;
        [...this.dots.children].forEach((dot, index) => dot.setAttribute('aria-current', index === nearest ? 'true' : 'false'));
        this.counter.textContent = this.counter.dataset.label.replace('[current]', nearest + 1).replace('[total]', this.points.length);
        this.style.setProperty('--mm-progress', `${((nearest + 1) / this.points.length) * 100}%`);
        this.previous.disabled = this.dataset.rewind !== 'true' && this.track.scrollLeft <= 2;
        this.next.disabled = this.dataset.rewind !== 'true' && this.track.scrollLeft >= this.max - 2;
      }
      announce() { this.status.textContent = this.status.dataset.label.replace('[current]', this.current + 1).replace('[total]', this.points.length); }
      move(direction) {
        if (!this.active) return;
        let target = this.current + direction;
        if (this.dataset.step === 'page') {
          const desired = this.track.scrollLeft + direction * this.track.clientWidth;
          target = direction > 0 ? this.points.findIndex(point => point >= desired - 2) : this.points.findLastIndex(point => point <= desired + 2);
          if (target < 0) target = direction > 0 ? this.points.length - 1 : 0;
        }
        if (this.dataset.rewind === 'true') {
          if (direction > 0 && this.track.scrollLeft >= this.max - 2) target = 0;
          if (direction < 0 && this.track.scrollLeft <= 2) target = this.points.length - 1;
        }
        this.go(Math.max(0, Math.min(this.points.length - 1, target)));
      }
      go(index) { this.track.scrollTo({ left: this.points[index], behavior: this.reduced.matches ? 'instant' : 'smooth' }); }
      disconnectedCallback() {
        this.controller?.abort(); this.resizeObserver?.disconnect(); this.headingBadgeObserver?.disconnect(); this.headingBadges?.clear();
        cancelAnimationFrame(this.startFrame); cancelAnimationFrame(this.resizeFrame); cancelAnimationFrame(this.scrollFrame); clearTimeout(this.announceTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-page-settings"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let frame;
    const update = () => {
      const hideNavigation = Boolean(document.querySelector('.ml-page-settings[data-hide-navigation]'));
      document.querySelectorAll('#header-group a.header-logo').forEach((logo) => {
        if (hideNavigation && logo.hasAttribute('href')) {
          logo.dataset.mlOriginalLogoHref = logo.getAttribute('href');
          logo.removeAttribute('href');
        } else if (!hideNavigation && logo.hasAttribute('data-ml-original-logo-href')) {
          logo.setAttribute('href', logo.dataset.mlOriginalLogoHref);
          delete logo.dataset.mlOriginalLogoHref;
        }
      });
    };
    const scheduleUpdate = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update, { once: true });
    } else {
      update();
    }
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ml-testimonials')) {
    customElements.define('ml-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.controller?.abort();
        this.editorObserver?.disconnect();
        cancelAnimationFrame(this.editorSyncFrame);
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.ml-testimonials__track');
        this.cards = [...this.track.querySelectorAll(':scope > .ml-review, :scope > .ml-testimonial-category > .ml-review')];
        this.filters = this.querySelector('.ml-testimonials__filters');
        this.controls = this.querySelector('.ml-testimonials__controls');
        this.dots = this.querySelector('.ml-testimonials__dots');
        this.counter = this.querySelector('.ml-testimonials__counter');
        this.status = this.querySelector('.ml-testimonials__status');
        this.previous = this.querySelector('.ml-testimonials__previous');
        this.next = this.querySelector('.ml-testimonials__next');
        this.observedVideos = new WeakSet();
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.categoryMap = new Map();
        this.cardCategories = new Map();
        this.cards.forEach(card => {
          const folder = card.closest('.ml-testimonial-category');
          const label = folder instanceof HTMLElement ? (folder.dataset.categoryLabel || '').trim() : '';
          const key = folder instanceof HTMLElement ? (folder.dataset.categoryKey || '').trim() : '';
          const keys = key && label ? [key] : [];
          if (key && label && !this.categoryMap.has(key)) this.categoryMap.set(key, label);
          this.cardCategories.set(card, keys);
          const cardPill = card.querySelector('[data-folder-category]');
          if (cardPill) {
            cardPill.textContent = label;
            cardPill.hidden = !label;
          }
        });
        this.filters.querySelectorAll('[data-generated]').forEach(button => button.remove());
        this.categoryMap.forEach((label, key) => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'ml-testimonials__filter'; button.dataset.filter = key; button.dataset.generated = '';
          button.textContent = label; button.setAttribute('aria-pressed', 'false'); button.setAttribute('aria-controls', this.track.id);
          this.filters.append(button);
        });
        this.filters.hidden = this.dataset.filters !== 'true' || !this.categoryMap.size;
        this.activeFilter = this.dataset.showAll !== 'false' ? '' : (this.categoryMap.keys().next().value || '');
        this.filters.addEventListener('click', event => {
          const button = event.target.closest('[data-filter]');
          if (!button) return;
          this.applyFilter(button.dataset.filter, true);
          this.centerSelectedFilter(true);
        }, { signal });
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.dots.addEventListener('click', event => {
          const button = event.target.closest('[data-page]');
          if (button) this.go(Number(button.dataset.page));
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        }, { signal, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !this.active) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault(); this.go(event.key === 'Home' ? 0 : this.points.length - 1);
          }
        }, { signal });
        this.track.addEventListener('play', event => {
          if (!(event.target instanceof HTMLVideoElement)) return;
          this.observeVideo(event.target);
          this.pauseVideos(event.target);
        }, { signal, capture: true });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseVideos(); }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.ml-review');
          if (!card || !this.contains(card)) return;
          const category = this.cardCategories.get(card)?.[0];
          if (card.hidden || (category && category !== this.activeFilter)) {
            const firstKey = this.filters.querySelector('[data-filter]')?.dataset.filter || '';
            this.applyFilter(category || firstKey, false);
            this.centerSelectedFilter(false);
          }
          cancelAnimationFrame(this.selectionFrame);
          this.selectionFrame = requestAnimationFrame(() => {
            this.layout();
            if (this.active) this.scrollToPosition(this.offset(card), 'instant');
          });
        }, { signal });
        this.resizeObserver = new ResizeObserver(entries => {
          const trackChanged = entries.some(entry => entry.target === this.track);
          const pillsChanged = entries.some(entry => entry.target === this.filters || entry.target.matches?.('[data-filter]'));
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => {
            if (trackChanged) this.layout();
            if (pillsChanged) this.centerSelectedFilter(false);
          });
        });
        this.resizeObserver.observe(this.track);
        this.resizeObserver.observe(this.filters);
        this.filters.querySelectorAll('[data-filter]').forEach(button => this.resizeObserver.observe(button));
        this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) {
            const player = entry.target.closest('deferred-media');
            if (typeof player?.pauseMedia === 'function') player.pauseMedia();
            else if (entry.target instanceof HTMLVideoElement) entry.target.pause();
          }
        }), { threshold: .1 });
        this.track.querySelectorAll('deferred-media, video').forEach(media => this.observeVideo(media));
        this.mobile.addEventListener('change', () => {
          this.pauseVideos();
          this.layout();
          this.centerSelectedFilter(false);
        }, { signal });
        this.applyFilter(this.activeFilter, false);
        this.centerSelectedFilter(false);
        if (window.Shopify?.designMode) {
          this.syncEditorCards();
          this.editorObserver = new MutationObserver(() => {
            cancelAnimationFrame(this.editorSyncFrame);
            this.editorSyncFrame = requestAnimationFrame(() => this.syncEditorCards());
          });
          this.editorObserver.observe(this.track, { childList: true, characterData: true, subtree: true });
        }
      }
      syncEditorCards() {
        const text = element => (element?.textContent || '')
          .replace(/<[^>]*>/g, '').replace(/&(?:nbsp|#160|#x0*a0);/gi, ' ')
          .replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
        const showText = element => {
          const visible = Boolean(text(element));
          if (element) element.hidden = !visible;
          return visible;
        };
        this.track.querySelectorAll(':scope > .ml-review, :scope > .ml-testimonial-category > .ml-review').forEach(card => {
          const hasTitle = showText(card.querySelector('.ml-review__title'));
          const hasQuote = showText(card.querySelector('.ml-review__quote'));
          const hasReview = hasTitle || hasQuote;
          const hasName = showText(card.querySelector('.ml-review__name'));
          const hasLocation = showText(card.querySelector('.ml-review__location'));
          const avatar = card.querySelector('.ml-review__avatar');
          const hasAvatar = Boolean(avatar?.getAttribute('src')?.trim() || avatar?.getAttribute('srcset')?.trim());
          if (avatar) avatar.hidden = !hasAvatar;
          const hasIdentity = hasName || hasLocation || hasAvatar;
          const verified = card.querySelector('.ml-review__verified');
          const hasVerified = Boolean(verified && text(verified) && (hasReview || hasIdentity));
          if (verified) verified.hidden = !hasVerified;
          const author = card.querySelector('.ml-review__author');
          const hasAuthor = hasIdentity || hasVerified;
          if (author) author.hidden = !hasAuthor;
          const authorDetails = card.querySelector('.ml-review__author-details');
          if (authorDetails) authorDetails.hidden = !(hasName || hasLocation || hasVerified);
          const hasStars = showText(card.querySelector('.ml-review__rating'));
          const hasCategory = showText(card.querySelector('.ml-review__category'));
          const topline = card.querySelector('.ml-review__topline');
          if (topline) topline.hidden = !(hasStars || hasCategory);
          const button = card.querySelector('.ml-review__button');
          const hasButton = Boolean(button && text(button) && button.getAttribute('href')?.trim() && button.getAttribute('aria-disabled') !== 'true');
          const buttonWrap = card.querySelector('.ml-review__button-wrap');
          if (buttonWrap) buttonWrap.hidden = !hasButton;
          const media = card.querySelector(':scope > .ml-review__media');
          const placeholder = card.querySelector('.ml-review__placeholder');
          const hasPlaceholder = Boolean(!media && text(placeholder));
          if (placeholder) placeholder.hidden = !hasPlaceholder;
          const hasBody = hasReview || hasAuthor || hasStars || hasCategory || hasButton || hasPlaceholder;
          const body = card.querySelector('.ml-review__content');
          if (body) body.hidden = !hasBody;
          card.classList.toggle('ml-review--media-only', Boolean(media && !hasBody && !card.querySelector(':scope > .ml-review__product')));
        });
        this.layout();
      }
      observeVideo(video) {
        if (this.observedVideos.has(video)) return;
        this.observedVideos.add(video);
        this.videoObserver.observe(video);
      }
      pauseVideos(except = null) {
        this.track?.querySelectorAll('deferred-media').forEach(player => {
          if (!player.contains(except) && typeof player.pauseMedia === 'function') player.pauseMedia();
        });
        this.track?.querySelectorAll('video').forEach(video => { if (video !== except) video.pause(); });
      }
      position() { return this.rtl ? -this.track.scrollLeft : this.track.scrollLeft; }
      offset(card) {
        const track = this.track.getBoundingClientRect();
        const bounds = card.getBoundingClientRect();
        const leading = (this.rtl ? track.right - bounds.right : bounds.left - track.left) + this.position();
        if (!this.active) return leading;
        return leading - (this.track.clientWidth - bounds.width) / 2;
      }
      scrollToPosition(position, behavior) { this.track.scrollTo({ left: this.rtl ? -position : position, behavior }); }
      centerSelectedFilter(animate) {
        const buttons = [...this.filters.querySelectorAll('[data-filter]')];
        const active = buttons.find(button => button.getAttribute('aria-pressed') === 'true');
        if (!active) return;
        const mobile = matchMedia('(max-width: 749px)').matches;
        const widths = buttons.map(button => button.getBoundingClientRect().width);
        const gap = parseFloat(getComputedStyle(this.filters).columnGap) || 0;
        const overflow = widths.reduce((sum, width) => sum + width, 0) + gap * (widths.length - 1) + 8 > this.filters.clientWidth + 1;
        if (!mobile && !overflow) {
          this.filters.style.justifyContent = 'center';
          this.filters.style.setProperty('--mt-filter-edge-start', '4px');
          this.filters.style.setProperty('--mt-filter-edge-end', '4px');
          this.filters.scrollTo({ left: 0, behavior: 'instant' });
          return;
        }
        this.filters.style.justifyContent = 'flex-start';
        this.filters.style.setProperty('--mt-filter-edge-start', '4px');
        this.filters.style.setProperty('--mt-filter-edge-end', `${Math.max(4, (this.filters.clientWidth - widths.at(-1)) / 2)}px`);
        const bounds = active.getBoundingClientRect();
        const viewport = this.filters.getBoundingClientRect();
        this.filters.scrollTo({
          left: active === buttons[0] ? 0 : this.filters.scrollLeft + bounds.left + bounds.width / 2 - viewport.left - viewport.width / 2,
          behavior: animate && !this.reduced.matches ? 'smooth' : 'instant'
        });
      }
      applyFilter(key, announce) {
        cancelAnimationFrame(this.filterFrame);
        this.track.style.scrollSnapType = 'none';
        this.pauseVideos(); this.activeFilter = key;
        this.cards.forEach(card => { card.hidden = Boolean(key) && !this.cardCategories.get(card).includes(key); });
        this.filters.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', button.dataset.filter === key ? 'true' : 'false'));
        this.layout();
        this.scrollToPosition(0, 'instant');
        this.filterFrame = requestAnimationFrame(() => {
          this.track.style.removeProperty('scroll-snap-type');
          this.scrollToPosition(0, 'instant');
          this.update();
        });
        if (announce) {
          const category = this.categoryMap.get(key) || this.filters.querySelector('[data-filter=""]').textContent;
          this.status.textContent = this.status.dataset.count.replace('[count]', this.visibleCards.length).replace('[category]', category);
        }
      }
      layout() {
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.active = (this.mobile.matches ? this.dataset.mobile : this.dataset.desktop) === 'carousel';
        this.visibleCards = this.cards.filter(card => !card.hidden);
        this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.points = [];
        this.visibleCards.forEach(card => {
          const point = Math.max(0, Math.min(this.max, this.offset(card)));
          if (!this.points.length || point - this.points[this.points.length - 1] > 2) this.points.push(point);
        });
        if (!this.points.length) this.points = [0];
        const pagination = this.mobile.matches ? this.dataset.paginationMobile : this.dataset.pagination;
        const arrows = this.mobile.matches ? this.dataset.arrowsMobile : this.dataset.arrows;
        this.controls.hidden = !this.active || this.max < 2 || (pagination === 'none' && arrows !== 'true');
        this.track.tabIndex = this.active && this.max > 2 ? 0 : -1;
        if (this.dots.children.length !== this.points.length) {
          this.dots.replaceChildren(...this.points.map((point, index) => {
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'ml-testimonials__dot'; button.dataset.page = index;
            button.setAttribute('aria-label', this.dots.dataset.label.replace('[number]', index + 1)); button.setAttribute('aria-controls', this.track.id);
            return button;
          }));
        }
        if (!this.active) this.scrollToPosition(0, 'instant');
        this.update();
      }
      update() {
        const position = this.position();
        let nearest = 0;
        this.points.forEach((point, index) => { if (Math.abs(point - position) < Math.abs(this.points[nearest] - position)) nearest = index; });
        this.current = nearest;
        [...this.dots.children].forEach((dot, index) => dot.setAttribute('aria-current', index === nearest ? 'true' : 'false'));
        this.counter.textContent = this.counter.dataset.label.replace('[current]', nearest + 1).replace('[total]', this.points.length);
        this.previous.disabled = this.dataset.rewind !== 'true' && position <= 2;
        this.next.disabled = this.dataset.rewind !== 'true' && position >= this.max - 2;
      }
      move(direction) {
        if (!this.active) return;
        let index = this.current + direction;
        if (this.dataset.rewind === 'true') index = (index + this.points.length) % this.points.length;
        this.go(Math.max(0, Math.min(this.points.length - 1, index)));
      }
      go(index) {
        if (!this.active || !Number.isInteger(index) || index < 0 || index >= this.points.length) return;
        this.scrollToPosition(this.points[index], this.reduced.matches ? 'instant' : 'smooth');
        this.status.textContent = this.status.dataset.page.replace('[current]', index + 1).replace('[total]', this.points.length);
      }
      disconnectedCallback() {
        this.pauseVideos?.(); this.controller?.abort(); this.resizeObserver?.disconnect(); this.videoObserver?.disconnect(); this.editorObserver?.disconnect();
        cancelAnimationFrame(this.startFrame); cancelAnimationFrame(this.resizeFrame); cancelAnimationFrame(this.scrollFrame); cancelAnimationFrame(this.selectionFrame); cancelAnimationFrame(this.filterFrame);
        cancelAnimationFrame(this.editorSyncFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
